import React, { useState } from 'react';
import { getTheme, useThemeMode } from '../theme';
import { HuntListing, resolveUrl } from '../api';
import { GREEN_PLACEHOLDER, fmtD, spotsColor } from './helpers';

export function HuntCard({ listing, inCart, onAddToCart, onClick }: {
  listing: HuntListing;
  inCart: boolean;
  onAddToCart: () => void;
  onClick: () => void;
}) {
  const { mode } = useThemeMode();
  const T = getTheme(mode);
  const [h, setH] = useState(false);
  const iF = listing.spotsAvailable <= 0;
  const imgSrc = listing.imageUrl ? resolveUrl(listing.imageUrl) : GREEN_PLACEHOLDER;
  const DC: Record<string, string> = { Nybörjare: '#27ae60', Medel: T.amber, Erfaren: '#e74c3c' };

  return (
    <div
      style={{ position: 'relative', cursor: 'pointer', borderRadius: 6, overflow: 'hidden', background: T.surface, border: `1px solid ${h ? T.borderHover : T.border}`, transition: 'border-color 0.2s, transform 0.2s, box-shadow 0.2s', transform: h ? 'translateY(-2px)' : 'none', boxShadow: h ? '0 12px 40px rgba(0,0,0,0.5)' : 'none' }}
      onMouseEnter={() => setH(true)} onMouseLeave={() => setH(false)} onClick={onClick}
    >
      <div style={{ position: 'relative', height: 220, overflow: 'hidden' }}>
        <img key={`hl-cover-${listing.id}`} src={imgSrc} alt={listing.title} style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.4s ease', transform: h ? 'scale(1.06)' : 'scale(1)' }} onError={e => { (e.target as HTMLImageElement).src = GREEN_PLACEHOLDER; }} />
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(19,46,16,0.9) 0%, rgba(0,0,0,0.1) 50%)' }} />
        <div style={{ position: 'absolute', top: 12, left: 12, display: 'flex', gap: 6, flexWrap: 'wrap', maxWidth: 'calc(100% - 24px)' }}>
          {(listing.gameTypes || []).map((gt, i) => (
            <span key={gt} style={{ background: i === 0 ? T.amber : T.surface, color: i === 0 ? '#000' : T.text, fontSize: 10, fontWeight: 700, padding: '3px 9px', borderRadius: 10, textTransform: 'uppercase', letterSpacing: '0.08em', border: i === 0 ? 'none' : `1px solid ${T.border}`, backdropFilter: 'blur(4px)' }}>{gt}</span>
          ))}
          {listing.featured && <span style={{ background: T.surfaceHover, color: T.text, fontSize: 10, fontWeight: 600, padding: '3px 9px', borderRadius: 10 }}>Utvald</span>}
        </div>
        <div style={{ position: 'absolute', bottom: 12, right: 12, opacity: h ? 1 : 0, transform: h ? 'translateY(0)' : 'translateY(8px)', transition: 'opacity 0.2s, transform 0.2s' }}>
          <button onClick={e => { e.stopPropagation(); if (!iF) onAddToCart(); }} style={{ background: inCart ? T.success : T.amber, color: '#000', border: 'none', borderRadius: 4, padding: '7px 14px', fontSize: 12, fontWeight: 700, cursor: iF ? 'default' : 'pointer', opacity: iF ? 0.4 : 1, whiteSpace: 'nowrap' }}>
            {iF ? 'Fullbokad' : inCart ? 'I korgen' : '+ Korg'}
          </button>
        </div>
        {!iF && (
          <div style={{ position: 'absolute', bottom: 12, left: 12 }}>
            <span style={{ background: 'rgba(0,0,0,0.7)', color: spotsColor(listing.spotsAvailable, listing.spotsTotal, T.success, T.danger), fontSize: 11, fontWeight: 600, padding: '3px 9px', borderRadius: 10 }}>{listing.spotsAvailable} platser kvar</span>
          </div>
        )}
      </div>
      <div style={{ padding: '16px 18px 18px' }}>
        <div style={{ color: T.textSub, fontSize: 11, marginBottom: 5, letterSpacing: '0.04em' }}>{listing.location} · {fmtD(listing.startDate)}</div>
        <div style={{ color: T.text, fontSize: 16, fontWeight: 700, letterSpacing: '-0.01em', lineHeight: 1.3, marginBottom: 8 }}>{listing.title}</div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            {listing.price > 0
              ? <><span style={{ color: T.accentText, fontSize: 17, fontWeight: 800 }}>{listing.price.toLocaleString('sv-SE')} kr</span><span style={{ color: T.textSub, fontSize: 12, marginLeft: 4 }}>{listing.priceUnit}</span></>
              : <span style={{ color: T.accentText, fontSize: 14, fontWeight: 700, background: 'rgba(193,127,58,0.12)', padding: '3px 10px', borderRadius: 10 }}>Kontakta för info</span>
            }
          </div>
          <span style={{ color: DC[listing.difficulty] ?? T.textSub, fontSize: 11, fontWeight: 600, background: 'rgba(255,255,255,0.04)', padding: '3px 9px', borderRadius: 10 }}>{listing.difficulty}</span>
        </div>
      </div>
    </div>
  );
}
